import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	clientIdLabelNonfinal: {
		defaultMessage: 'Application client ID',
		id: 'applinks.administration.ui.common.fields.client-id.label-nonfinal',
		description:
			'Label for the Client ID field. Also used in Copy button tooltip i.e. Copy "Application Client ID".',
	},
	clientSecretLabelNonfinal: {
		defaultMessage: 'Application client secret',
		id: 'applinks.administration.ui.common.fields.client-secret.label-nonfinal',
		description:
			'Label for the Client Secret field. Also used in Copy button tooltip i.e. Copy "Application Client Secret".',
	},
	remoteApplicationScopesLabelNonfinal: {
		defaultMessage: 'Remote application scopes',
		id: 'applinks.administration.ui.common.fields.remote-application-scopes.label-nonfinal',
		description:
			'Label for the Remote Application Scopes drop-down. The "Application" terminology should match Application URL',
	},
	remoteApplicationScopesPlaceholderNonfinal: {
		defaultMessage: 'Use the same scopes as the remote application',
		id: 'applinks.administration.ui.common.fields.remote-application-scopes.placeholder-nonfinal',
		description:
			'Placeholder text for the Remote Application Scopes drop-down, instructing the user which items to select',
	},
	redirectUrlLabelNonfinal: {
		defaultMessage: 'Redirect URL',
		id: 'applinks.administration.ui.common.fields.redirect-url.label-nonfinal',
		description: 'Label for the Redirect URL field.',
	},
	displayNameLabelNonfinal: {
		defaultMessage: 'Display name',
		id: 'applinks.administration.ui.common.fields.display-name.label-nonfinal',
		description: 'Label for the Display Name field.',
	},
	displayNamePlaceholderNonfinal: {
		defaultMessage: 'Name for the application link',
		id: 'applinks.administration.ui.common.fields.display-name.placeholder-nonfinal',
		description: 'Placeholder text for the Display Name field.',
	},
	displayNameHelperMessageNonfinal: {
		defaultMessage:
			'Enter a unique name for the link, for example the name of your external application.',
		id: 'applinks.administration.ui.common.fields.display-name.helper-message-nonfinal',
		description: 'Helpful message displayed below the Display Name field.',
	},
	displayUrlLabelNonfinal: {
		defaultMessage: 'Display URL',
		id: 'applinks.administration.ui.common.fields.display-url.label-nonfinal',
		description: 'Label for the Display URL field.',
	},
	displayUrlPlaceholderNonfinal: {
		defaultMessage: 'URL for the application link',
		id: 'applinks.administration.ui.common.fields.display-url.placeholder-nonfinal',
		description: 'Placeholder text for the Display URL field.',
	},
	displayUrlHelperMessageNonfinal: {
		defaultMessage: 'This is the URL that will be displayed to users in {productName}.',
		id: 'applinks.administration.ui.common.fields.display-url.helper-message-nonfinal',
		description:
			'Helpful message displayed below the Display URL field. Product Name is the current product i.e. "Jira"',
	},
	applicationUrlLabelNonfinal: {
		defaultMessage: 'Application URL',
		id: 'applinks.administration.ui.common.fields.application-url.label-nonfinal',
		description:
			'Label for the Application URL field. The "Application" terminology should match Application Scopes',
	},
	applicationUrlPlaceholderNonfinal: {
		defaultMessage: 'Application URL for the application link',
		id: 'applinks.administration.ui.common.fields.application-url.placeholder-nonfinal',
		description: 'Placeholder text for the Application URL field.',
	},
	applicationUrlHelperMessageNonfinal: {
		defaultMessage:
			'This is the URL that {productName} will use to communicate with the external application.',
		id: 'applinks.administration.ui.common.fields.application-url.helper-message-nonfinal',
		description:
			'Helpful message displayed below the Application URL field. Product Name is the current product i.e. "Jira"',
	},
});
